import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import BookingProgressBar from '../BookingProgressBar';
import {FONT_FAMILY, FONT_FAMILY_BOLD, FONT_FAMILY_LIGHT} from "../../constants/styleConstants";
import {actuatedNormalize} from "../../services/helpers/stylingHelpers";
import moment from "moment";
import ButtonsContainer from "../ButtonsContainer";
import {useSelector} from "react-redux";
import {
    getCurrentBooking,
    getConfig,
    getNextBooking,
    getMaintenance,
    getConnectionStatus
} from "../../reducers/configSlice";

const RoomDetails = () => {
    const config = useSelector(getConfig)
    const currentBooking = useSelector(getCurrentBooking)
    const nextBooking = useSelector(getNextBooking)
    const maintenance = useSelector(getMaintenance)
    const connectionStatus = useSelector(getConnectionStatus)

    const getEarlyCheckin = () => {
        return !maintenance && currentBooking && currentBooking.early && config.has_checkin ? (
            <Text style={styles.earlyCheckin}>
                {"Early check-in available"} {/* Adjust translation as needed */}
            </Text>
        ) : null;
    };

    const getBookingName = () => {
        const title = currentBooking
            ? currentBooking.title
            : nextBooking
                ? translate("Room available until %s", [moment(nextBooking.start).format('LT')])
                : maintenance
                    ? `Maintenance: ${maintenance.name}`
                    : translate("Room available for the rest of the day");

        return (
            <Text numberOfLines={1} ellipsizeMode="tail" style={styles.bookingName}>
                {title}
            </Text>
        );
    };

    const getBookingInfo = () => {
        if (maintenance) {
            return (
                <Text style={styles.bookingInfo}>
                    {`until ${moment(maintenance.end).format(config.date_format + ' LT')}`} {/* Adjust format as needed */}
                </Text>
            );
        }

        if (currentBooking) {
            return (
                <Text style={styles.bookingInfo}>
                    {`${moment(currentBooking.start).format('LT')} - ${moment(currentBooking.end).format('LT')}`} {/* Adjust format as needed */}
                    {!config.hide_booker && (currentBooking.organizer && currentBooking.organizer.name ? `hosted by ${currentBooking.organizer.name}` : '')}
                </Text>
            );
        }

        return null;
    };

    const getBookingProgressBar = () => {
        return currentBooking ? <BookingProgressBar /> : null;
    };

    return (
        <View style={[styles.roomDetails, !connectionStatus && {opacity: 0.6}]}>
            <Text style={[styles.roomName]}>
                {config.space_name}
            </Text>
            {!config.hide_current_booking_details ? getEarlyCheckin() : null}
            {!config.hide_current_booking_details && !config.hide_booking_title ? getBookingName() : null}
            {!config.hide_current_booking_details ? getBookingInfo() : null}
            {!config.hide_current_booking_details ? getBookingProgressBar() : null}
            {!maintenance ? <ButtonsContainer /> : null}
        </View>
    );
};

const styles = StyleSheet.create({
    roomDetails: {
        flex: 0.67,
        justifyContent: 'center',
    },
    roomName: {
        color: '#FFFFFF',
        fontFamily: FONT_FAMILY,
        fontSize: actuatedNormalize(36),
    },
    earlyCheckin: {
        fontSize: actuatedNormalize(20),
        fontFamily: FONT_FAMILY_LIGHT,
        color: '#cfcfcf',
    },
    bookingName: {
        paddingTop: '2%',
        fontFamily: FONT_FAMILY_BOLD,
        color: '#FFFFFF',
        fontSize: actuatedNormalize(22),
    },
    bookingInfo: {
        fontFamily: FONT_FAMILY_LIGHT,
        fontSize: actuatedNormalize(20),
        color: '#FFFFFF',
        marginBottom: '2%',
    },
});

export default RoomDetails;
